<template>
  <div class="fpc_corner-box">
    <div class="fpc_page-tip" @click="prev" v-if="pageType === 'left'">
      <div class="fpc_corner-contents">
        <div class="fpc_corner-button">
          <!-- <strong>Click Here </strong> and description text lines -->
        </div>
      </div>
    </div>
    <div class="fpc_page-tip" @click="next" v-else>
      <div class="fpc_corner-contents">
        <div class="fpc_corner-button">
          <!-- <strong>Click Here </strong> and description text lines -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tr-page-corner',
  props: {
    pageType: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {};
  },
  methods: {
    prev() {
      this.$emit('clearCanvas');
      this.$emit('previusPage');
    },
    next() {
      this.$emit('clearCanvas');
      this.$emit('nextPage');
    },
  },
  computed: {},
};
</script>
